@if (apiFragment$ | async; as record) {
  <dt class="sh-description-list__term">{{ label }}</dt>
  <dd class="sh-description-list__details edp-subject-process-details">
    @if (record.metadata.Dynamic.SeriesServiceIpdc; as service) {
      <a [href]="record.metadata.Dynamic.SeriesServiceIpdc.URL" class="sh-link" target="_blank">
        {{ record.metadata.Dynamic.SeriesServiceIpdc.Name || '-' }}
      </a>
    } @else {
      -
    }
  </dd>
}
